import * as React from 'react';

interface IProps {
    title: string,
    content: string,

    onCancel: () => void;
    onContinue: () => void;
}

interface IState {

}

export class ContextSwitchDialog extends React.Component<IProps, IState> {

    render() {
        const { onCancel, onContinue } = this.props;

        return (
            <div id="advanced-search-menu-wrapper" className="advanced-search-menu-wrapper" style={{ display: 'block' }}>
                <div className="dialog">
                    <div className="advanced-search-menu-container" >
                        <h5 className="advanced-search-menu-title" dangerouslySetInnerHTML={{ __html: this.props.title }} />
                        <p className="advanced-search-menu-prompt" dangerouslySetInnerHTML={{ __html: this.props.content }} />
                    </div>
                    <div className="dialog-action">
                        <a className="advanced-search-menu-button" id="advanced-search-keywords-close" onClick={onCancel}>Cancel</a>
                        <a className="advanced-search-menu-button" id="advanced-search-keywords-close" onClick={onContinue}>Continue</a>
                    </div>
                </div >
            </div>
        )
    }

};
